// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionAction, PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { USERS_TEAMS_TABS, UsersTeamsPage, type UsersTeamsTab } from '#components/domain/operations/settings/users-teams/users-teams-page.tsx'

export const Route = createFileRoute('/_appSettings/$companyId/settings/users-teams')({
  validateSearch: (search: Record<string, unknown>): { tab?: UsersTeamsTab } => ({
    tab: USERS_TEAMS_TABS.find(tab => tab === search.tab),
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { tab } = Route.useSearch()
  return (
    <PermissionGuard
      permissions={[[
        [PermissionService.AUTH_USERS, PermissionAction.READ],
      ]]}
      redirectOnNotAuthorized
    >
      <UsersTeamsPage initialTab={tab} />
    </PermissionGuard>
  )
}
